import { AvailableLanguage, getLanguagesArray } from './AvailableLanguages'

export const getBrowserLocales = (options = {}) => {
  const defaultOptions = {
    languageCodeOnly: false
  }

  const opt = {
    ...defaultOptions,
    ...options
  }

  const browserLocales =
    navigator.languages === undefined
      ? [navigator.language]
      : navigator.languages

  if (!browserLocales) {
    return undefined
  }

  return browserLocales.map((locale) => {
    const trimmedLocale = locale.trim()

    return opt.languageCodeOnly ? trimmedLocale.split(/-|_/)[0] : trimmedLocale
  })
}

/**
 * Returns the first locale that is compatible in browser with the available locales
 */
export const getNavigatorCompatibleLocale = (): AvailableLanguage | void => {
  const availableLocales = getLanguagesArray()
  const navigatorLocales = getBrowserLocales()
  if (navigatorLocales) {
    navigatorLocales.forEach((locale) => {
      if (availableLocales.includes(locale)) {
        return locale as AvailableLanguage
      }
    })
  }
}
